import 'css-chunk:src/app/containers/Application/ApplicationContainer.scss';export default {
  "ApplicationContainer": "_ApplicationContainer_11eiq_1",
  "modalView": "_modalView_11eiq_8"
};